export const apiUrl = `${process.env.NODE_ENV === 'production' ? 'https' : 'http'}://${process.env.REACT_APP_API_URL}`;